import { useQuery } from '@tanstack/react-query';
import type { PartnerFacilitiesFilter } from '../services/PartnerFacilityFilterService';
import { getPartnerFacilityFilterData } from '../services/PartnerFacilityFilterService';
export const useGetPartnerFacilityFilterData = () => {
  const { data, isLoading, isError, error, refetch } =
    useQuery<PartnerFacilitiesFilter>({
      queryKey: ['PartnerFacilityFilterData'],
      queryFn: async () => {
        const data = await getPartnerFacilityFilterData();
        return data;
      },
      staleTime: 0,
      gcTime: 0,
      enabled: false,
    });

  return {
    PartnerFacilityFilterData: data,
    isLoading,
    isError,
    error,
    refetch,
  };
};
